import { useQuery } from '@apollo/client';
import { EWorldMapSetType } from '__generated__/globalTypes';
import {
    WorldMapMarkerStory,
    WorldMapMarkerStoryVariables
} from 'graphql/query/__generated__/WorldMapMarkerStory';
import { WORLD_MAP_MARKER_STORY_QUERY } from 'graphql/query/worldQuery';
import { useViewMapQueryParams } from 'hooks/map/useViewMapQueryParams';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { useContext, useEffect } from 'react';
import { CtxView } from 'session/ctxView';

export const useLoadMarkers = (mapId: string) => {
    const ctxView = useContext(CtxView);
    const { getTokenForMapId } = useWorldMapLocalStorage();
    const params = useViewMapQueryParams();
    const marker = useQuery<WorldMapMarkerStory, WorldMapMarkerStoryVariables>(
        WORLD_MAP_MARKER_STORY_QUERY,
        {
            variables: {
                worldMapId: mapId,
                token: getTokenForMapId(mapId),
                language: params.language
            },
            skip: !mapId
        }
    );

    useEffect(() => {
        if (marker.data?.worldMapView?.markers && ctxView.map) {
            const markers = marker.data.worldMapView.markers;
            const categories = ctxView.map.worldMapSets.filter(
                (e) => e.type === EWorldMapSetType.CATEGORY
            );

            // This is quite hacky way to inject categories into marker of React type
            const mappedMarkers = markers.map((marker) => {
                if (marker.data.__typename !== 'WorldMapMarkerDataReact') {
                    return marker;
                }

                const categoryComponentData = {
                    name: 'categories' as const,
                    value: categories
                        .filter((e) =>
                            e.markers.some((f) => f.worldMapMarkerId === marker.worldMapMarkerId)
                        )
                        .map((e) => e.worldMapSetId)
                        .join(';'),
                    __typename: 'WorldMapMarkerDataReactComponentData' as const
                };

                return {
                    ...marker,
                    data: {
                        ...marker.data,
                        componentData: [...marker.data.componentData, categoryComponentData]
                    }
                };
            });

            ctxView.setMarkers(mappedMarkers);
        }
    }, [marker.data?.worldMapView?.worldMapId, mapId, ctxView.map?.worldMapId]);
};
